/* eslint-disable react/jsx-wrap-multilines */

import React from 'react'
import Avatar from './Avatar'
import { Box } from 'grommet'

class Members2 extends React.Component {
  
  render() {
    const members = this.props.members
  
    return(
      <Box direction='row' style={{flexWrap: 'wrap'}}>
        { members.map(member => (
          <Avatar
            key={member.id}
            color='black'
            title={member.firstname}
            subtitle={member.lastname}
            iconName = {member.iconName}
            backgroundColor={member.backgroundColor}
          />
        ))}
      </Box>
    )
  }
}

export default Members2
